export default __webpack_public_path__ + "static/media/logo-alethio.33108bd4.png";